import bus from "../../admin-bus";
import { MODAL_CLOSE } from "../../action-types";

/**
 * Informs the modal that its submission has been successful and
 * passes data from component back.
 * @param  {Node} el Element
 * @return {Void}
 */

export default function modalSuccess(el, props) {
  bus.emit(MODAL_CLOSE, { success: true, data: props });
}
